import _ from 'lodash';

// 年齡頁共用：站點網址、評分 emoji、產品正規化、產品 JSON-LD。
// /age/[ageGroup]/[category] 與 /age/[ageGroup]/[category]/[subCategory] 共用。

export const SITE = 'https://www.sorra.net';

// 0-100 評分 → emoji
export const ratingEmoji = (rate) =>
  rate >= 79 ? '❤️' : rate >= 49 ? '👌' : '🤔';

// 將 go-api 產品正規化成 ProductCard 期望的形狀（origin/store 取 id、rating→ratings）
export const normalizeProduct = (p) => ({
  ...p,
  origin:
    p.origin && typeof p.origin === 'object'
      ? p.origin.id ?? null
      : p.origin ?? null,
  ratings: p.rating || p.ratings || null,
  stores: (p.stores || []).map((s) => ({
    ...s,
    store:
      s.store && typeof s.store === 'object' ? s.store.id ?? null : s.store ?? null,
  })),
});

// 產品 JSON-LD（ItemList / Product 用）
export const buildProductSchema = (p, categoryName) => {
  const productName = p.name || p.en_name || '';
  const brandName = (p.brand && p.brand.name) || '';
  const images = (p.images || []).map((i) => i && i.url).filter(Boolean);
  const ratings = p.ratings || p.rating || {};
  const rate = ratings.rate || 0;
  const total = ratings.total || 0;
  const offers = (p.stores || [])
    .filter((s) => s && s.price != null && s.url)
    .map((s) => ({
      price: String(s.price),
      priceCurrency: 'HKD',
      url: s.url,
      availability: 'https://schema.org/InStock',
    }));
  return {
    id: p.id,
    productName,
    brand: brandName,
    description: `${brandName} ${productName} 的真實評價、價格比較、成份分析`,
    images: images.length > 0 ? images : ['/images/placeholders/product.png'],
    aggregateRating:
      total > 0
        ? {
            ratingValue: _.round(5 * (rate / 100), 1).toString(),
            reviewCount: String(total),
            worstRating: '0',
            bestRating: '5',
          }
        : null,
    category: categoryName || null,
    offers: offers.length > 0 ? offers : null,
  };
};
